// this constants uses for some common functions, currently this for redirect.
// you need add handler sagas in mobile if you need redirect on mobile-app
// eslint-disable-next-line
export const HANDLE_REDIRECT = 'COMMON/HANDLE_REDIRECT';
